module.exports = __webpack_public_path__ + "img/lam.6b7d0af1.jpg";